import React from 'react';
import { PlanSelect } from '../_components/PlanSelect';
import { AddonSelect } from '../_components/AddonSelect';
import { useAddCouponBootstrap } from './add-coupon.bootstrap.hook';

export default function AddCouponV2(props) {
  const couponId = props.match.params.id;
  const {
    notFound,
    fetchingCoupon,
    formik,
    plans,
    plansLoading,
    addons,
    addonsLoading,
    addRule,
    removeRule,
    updateRule,
    handleCancel,
    valueTypeOptions,
    appliesToOptions,
    cyclesOptions,
  } = useAddCouponBootstrap(couponId, props.location.state?.coupon);

  if (notFound) {
    return (
      <div>
        <span>
          Cupom não encontrado. Volte para a listagem e tente novamente.
        </span>
      </div>
    );
  }

  if (fetchingCoupon) {
    return (
      <div>
        <span>Carregando dados do cupom...</span>
      </div>
    );
  }

  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <div className="card card-custom" style={{ padding: '3.5rem' }}>
          <div className="mt-4">
            <div
              className="d-flex align-content-between justify-content-between"
              style={{ gap: '8px', marginBottom: '2rem' }}
            >
              <h1 className="azul-cabecalho">
                {couponId ? 'Editar cupom' : 'Criar cupom'}
              </h1>
              <div className="d-flex flex-md-row" style={{ gap: '8px' }}>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleCancel}
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={formik.isSubmitting}
                >
                  {formik.isSubmitting ? 'Salvando...' : 'Salvar'}
                </button>
              </div>
            </div>
            <div className="form-group row">
              <div className="col-lg-6">
                <label>Nome do cupom</label>
                <input
                  type="text"
                  className="form-control"
                  {...formik.getFieldProps('code')}
                />
                {formik.touched.code && formik.errors.code && (
                  <div className="text-danger">{formik.errors.code}</div>
                )}
              </div>
              <div className="col-lg-6 text-lg-right">
                <label>Ciclos aplicáveis</label>
                <select
                  className="form-control"
                  {...formik.getFieldProps('cyclesCount')}
                >
                  {cyclesOptions.map((cycles) => (
                    <option key={cycles} value={cycles}>
                      {cycles} {cycles === 1 ? 'ciclo' : 'ciclos'}
                    </option>
                  ))}
                </select>
                {formik.touched.cyclesCount && formik.errors.cyclesCount && (
                  <div className="text-danger">{formik.errors.cyclesCount}</div>
                )}
              </div>
            </div>

            <div className="form-group row">
              <div className="col-lg-6">
                <label>Data de início</label>
                <input
                  type="date"
                  className="form-control"
                  {...formik.getFieldProps('startsAt')}
                />
                {formik.touched.startsAt && formik.errors.startsAt && (
                  <div className="text-danger">{formik.errors.startsAt}</div>
                )}
              </div>
              <div className="col-lg-6">
                <label>Data de expiração</label>
                <input
                  type="date"
                  className="form-control"
                  {...formik.getFieldProps('expiresAt')}
                />
                {formik.touched.expiresAt && formik.errors.expiresAt && (
                  <div className="text-danger">{formik.errors.expiresAt}</div>
                )}
              </div>
            </div>

            <div className="form-group row">
              <div className="col-lg-6">
                <label>Ativo</label>
                <select
                  className="form-control"
                  value={formik.values.active ? 'true' : 'false'}
                  onChange={(e) =>
                    formik.setFieldValue('active', e.target.value === 'true')
                  }
                >
                  <option value="true">Sim</option>
                  <option value="false">Não</option>
                </select>
              </div>
              <div className="col-lg-6" />
            </div>
          </div>
          <div className="mt-4">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h3 className="card-label">Descontos</h3>
              <button
                type="button"
                className="btn btn-sm btn-light-primary"
                onClick={addRule}
              >
                + Adicionar desconto
              </button>
            </div>

            {formik.values.rules.map((rule, index) => (
              <div
                key={index}
                style={{
                  background: '#F4F5F9',
                  borderRadius: '8px',
                  padding: '16px',
                  marginBottom: '12px',
                }}
              >
                <div
                  className="d-flex align-items-start"
                  style={{ gap: '12px' }}
                >
                  <div style={{ flex: 1 }}>
                    <div
                      className="form-group row"
                      style={{ marginBottom: '1rem' }}
                    >
                      <div className="col-lg-4">
                        <label>Aplicável em</label>
                        <select
                          className="form-control"
                          value={rule.scope}
                          onChange={(e) =>
                            updateRule(index, 'scope', e.target.value)
                          }
                        >
                          {appliesToOptions.map((opt) => (
                            <option key={opt.value} value={opt.value}>
                              {opt.label}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-lg-4">
                        <label>Tipo</label>
                        <select
                          className="form-control"
                          value={rule.valueType}
                          onChange={(e) =>
                            updateRule(index, 'valueType', e.target.value)
                          }
                        >
                          {valueTypeOptions.map((opt) => (
                            <option key={opt.value} value={opt.value}>
                              {opt.label}
                            </option>
                          ))}
                        </select>
                        {formik.errors.rules?.[index]?.valueType && (
                          <div className="text-danger">
                            {formik.errors.rules[index].valueType}
                          </div>
                        )}
                      </div>
                      <div className="col-lg-4">
                        <label>Valor</label>
                        <input
                          type="number"
                          className="form-control"
                          value={rule.value}
                          onChange={(e) =>
                            updateRule(index, 'value', e.target.value)
                          }
                        />
                        {formik.errors.rules?.[index]?.value && (
                          <div className="text-danger">
                            {formik.errors.rules[index].value}
                          </div>
                        )}
                      </div>
                    </div>

                    {rule.scope === 'PLAN' && (
                      <PlanSelect
                        plans={plans}
                        plansLoading={plansLoading}
                        value={rule.planId}
                        onChange={(id) => updateRule(index, 'planId', id)}
                        error={formik.errors.rules?.[index]?.planId}
                      />
                    )}
                    {['ADDON_TOTAL', 'ADDON_ITEM'].includes(rule.scope) && (
                      <AddonSelect
                        addons={addons}
                        addonsLoading={addonsLoading}
                        value={rule.addonId}
                        onChange={(id) => updateRule(index, 'addonId', id)}
                        error={formik.errors.rules?.[index]?.addonId}
                      />
                    )}
                  </div>

                  <button
                    disabled={index === 0}
                    type="button"
                    className="btn btn-icon btn-light-danger btn-sm"
                    style={{ marginTop: '28px' }}
                    title="Remover desconto"
                    onClick={() => removeRule(index)}
                  >
                    <i className="ki ki-close icon-sm"></i>
                  </button>
                </div>
              </div>
            ))}
          </div>
          <div className="mt-4">
            <h3 className="card-label mb-3">Observação</h3>
            <textarea
              className="form-control"
              rows={4}
              {...formik.getFieldProps('description')}
            />
          </div>
        </div>
      </form>
    </>
  );
}
